import { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import { useAuth } from './AuthContext';

const EditModeContext = createContext(null);

const ELEVATED = ['admin', 'prelate'];

export const EditModeProvider = ({ children }) => {
  const { user } = useAuth();
  const canEdit = !!user && ELEVATED.includes(user.role);
  const [editMode, setEditMode] = useState(() => {
    return canEdit && localStorage.getItem('wi_edit_mode') === '1';
  });

  useEffect(() => {
    if (!canEdit && editMode) setEditMode(false);
  }, [canEdit, editMode]);

  const toggle = useCallback(() => {
    setEditMode(prev => {
      const next = !prev;
      if (next) localStorage.setItem('wi_edit_mode', '1');
      else localStorage.removeItem('wi_edit_mode');
      return next;
    });
  }, []);

  const value = useMemo(() => ({ editMode, canEdit, toggle, setEditMode }), [editMode, canEdit, toggle]);

  return (
    <EditModeContext.Provider value={value}>
      {children}
    </EditModeContext.Provider>
  );
};

export const useEditMode = () => useContext(EditModeContext) || { editMode: false, canEdit: false };
